import { vendey, pipe } from './api.js';
export async function uploadProductImage(id, file) {
  if (!(Number(id) > 0)) throw new Error('Guarda primero el producto.');
  if (!file || !/^image\/(jpeg|png|webp|gif)$/.test(file.type) || file.size > 10 * 1024 * 1024) throw new Error('Selecciona una imagen JPG, PNG, WebP o GIF de hasta 10 MB.');
  const data = new FormData(); data.append('image', file);
  const response = await fetch(import.meta.env.VITE_IMAGE_UPLOAD_ENDPOINT || 'https://api.imgbb.com/1/upload?key=5fe4096a939df6a89692dce90961a078', { method: 'POST', body: data });
  const result = await response.json();
  if (!response.ok || !result.success || !/^https:\/\//.test(result.data?.url || '')) throw new Error(result.error?.message || 'No se pudo subir la imagen.');
  const url = result.data.url;
  await vendey('spINVACTUALIZARIMAGENCSVWEB', pipe([id, url]));
  return url;
}
